import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { installAuthInterceptor } from '@/api/client';
import { useAuth } from '@/providers/AuthProvider/AuthProvider';

export const AuthInterceptor = () => {
    const auth = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        return installAuthInterceptor({
            refreshToken: auth.actions.refreshToken,
            onAuthFailed: () => {
                void auth.actions.logout();
                navigate('/login');
            },
        });
    }, [auth.actions, navigate]);

    return null;
};
